/**
 * Este componente exibe a tela de confirmação quando um usuário rejeita um convite de vinculação.
 * Mostra uma mensagem informando que o convite foi recusado e oferece a opção de retornar ao painel.
 */
import React from 'react';
import { faTimes } from "@fortawesome/free-solid-svg-icons"; // Ícone X para indicar recusa
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';

/**
 * Componente de visualização do estado de convite recusado
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.rejectedUserName - Nome do usuário cujo convite foi rejeitado
 * @param {Object} props.newParentUser - Dados do usuário que enviou o convite
 * @param {Function} props.redirectToDashboard - Função para redirecionar o usuário ao painel
 * @returns {JSX.Element} - Interface de confirmação de rejeição do convite
 */
const RejectedView = ({ rejectedUserName, newParentUser, redirectToDashboard }) => {
  return (
    <StateView className={classes.rejectedContainer}>
      {/* Título da tela */}
      <H1 className={classes.rejectedTitle}>Convite recusado</H1>

      {/* Mensagem informativa sobre a recusa do convite */}
      <LinkMessage className={classes.rejectedMessage}>
        <p>Você recusou o convite de vinculação de <strong>{
          // Usa o primeiro valor não-vazio entre: rejectedUserName, nome do usuário convidante, ou "um profissional"
          rejectedUserName || newParentUser?.given_name || "um profissional"
        }</strong>.</p>
      </LinkMessage>

      {/* Ícone de X (faTimes) para indicar visualmente a recusa */}
      <StateIcon 
        icon={faTimes}
        iconContainerClass={classes.rejectedIconContainer}
        iconClass={classes.rejectedIcon}
      />

      {/* Botão para retornar ao painel principal */}
      <RoundedButton
        className={classes.returnButton}
        text="VOLTAR AO PAINEL"
        onClick={redirectToDashboard}
      />
    </StateView>
  );
};

export default RejectedView;